export const FALLBACK_AVERAGE_RENTOUT_DAY = 11;
export const FALLBACK_ACTIVE_TENANT_COUNT_NETHERLANDS = 11008;
